import { TuiCheckboxLabeledModule, TuiCheckboxModule, TuiMultiSelectGroupComponent } from '@taiga-ui/kit';
import { TuiExpandModule, TuiLabelModule, TuiLinkModule, TuiTextfieldSizeDirective } from '@taiga-ui/core';
import { TuiLetModule } from '@taiga-ui/cdk';
import { FormsModule } from '@angular/forms';
import { ChangeDetectionStrategy, Component, ContentChild, inject } from '@angular/core';
import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';

import { MultiSelectGroupLabelDirective } from './multi-select-group-label.directive';

import { ExpandIconComponent } from '@iss/core/table';

@Component({
  selector: 'wo-multi-select-group',
  templateUrl: './multi-select-group.component.html',
  styleUrls: [ './multi-select-group.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AsyncPipe,
    ExpandIconComponent,
    FormsModule,
    NgIf,
    NgTemplateOutlet,
    TuiCheckboxLabeledModule,
    TuiCheckboxModule,
    TuiExpandModule,
    TuiLabelModule,
    TuiLetModule,
    TuiLinkModule,
  ],
})
export class MultiSelectGroupComponent<T> extends TuiMultiSelectGroupComponent<T> {
  public expanded = false;
  private readonly sizeDirective = inject(TuiTextfieldSizeDirective, { optional: true });

  @ContentChild(MultiSelectGroupLabelDirective) public templateLabel?: MultiSelectGroupLabelDirective;

  public get small() {
    return this.sizeDirective?.size === 's';
  }
}
